export default __webpack_public_path__ + "static/media/3066.78f78a58.jpg";